export const getNestedOptionsData = (data) => {
  const map = data.reduce((acc, item) => {
    acc[item.id] = { ...item, options: [] };
    return acc;
  }, {});

  return data.reduce((acc, item) => {
    if (map[item.parentId]) {
      map[item.parentId].options.push(map[item.id]);
    } else {
      acc.push(map[item.id]);
    }
    return acc;
  }, []);
};
